$(function() {
  // ボタンにマウスオーバーしたら
  $(document).on(
    {
      'touchstart': function() {
        return $(this).off('mouseenter mouseleave');
      },

      'touchstart mouseenter':function(){
        $(this).children('.js-tipBalloon').addClass('is-open');
        
      },
      'mouseleave':function(){
        $(this).children('.js-tipBalloon').removeClass('is-open');
      }
    },
    '.js-tooltip'
  )

})
